
const ButtonSound = cc.Enum({
    CLICK_SOUND_1: 0
});
cc.Class({
    extends: cc.Component,

    properties: {
        clickSound: {
            type: ButtonSound,
            default: ButtonSound.CLICK_SOUND_1
        }
    },

    onLoad () {
        const PSSound = cc.find('PSUIInitializer/PSUI/Sound').getComponent('PSSound');

        this.node.on('click', () => {
            PSSound.playSfx(this.clickSound)
        }, this);
    }
});
